// React
import { FunctionComponent } from "react";
// Library
import { Title } from "@fyrstain/fhir-front-library";
import i18n from "i18next";
// Components
import PapyrusPage from "../../components/PapyrusPage/PapyrusPage";
// Styles
import styles from "./Home.module.css";

const Home: FunctionComponent = () => {
    return (
        <PapyrusPage loading={false} needsLogin={false}>
            <>
                <div className={styles.mainHomeContainer}>
                    <img
                        className={styles.homeimageIcon}
                        alt={i18n.t("accessibility.homeimage")}
                        src={(process.env.PUBLIC_URL ?? "") + "/assets/home_diagnostic_reports.png"}
                    />
                    <Title level={1} prefix={'Papyrus'} />
                </div>
            </>
        </PapyrusPage>
    );
};

export default Home;
